"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var SnowplowProvider_1 = __importDefault(require("./SnowplowProvider"));
/**
 * React Element for implementing Snowplow
 *
 * @param props all required and optional props for the Tracker initialization
 */
var Snowplow = function Snowplow(_ref) {
  var configuration = _ref.configuration,
    children = _ref.children;
  return react_1["default"].createElement(SnowplowProvider_1["default"], {
    configuration: configuration
  }, children);
};
exports["default"] = Snowplow;